<template>
  <div>
    <b-card>
      <titleSection
        title="Requerimientos del sistema"
        subtitle="Para el funcionamiento óptimo de la plataforma."
        icon="CpuIcon"
      />

      <h5 class="text-primary mb-75 mt-2">
        <b>Requerimientos</b>
      </h5>

      <b-card-text class="mr-5 ml-1">
        <div
          v-for="(requerimiento, index) in requerimientos"
          :key="index"
        >
          <h5 class="smb-75 mt-2">
            <b>{{ requerimiento.titulo }}</b>
          </h5>
          <!-- eslint-disable vue/no-v-html -->
          <p
            v-for="(elemento, index2) in requerimiento.particular"
            :key="index2"
            class="text-justify"
            v-html="elemento.text"
          />
        </div>
      </b-card-text>
    </b-card>
  </div>
</template>

<script>
import {
  BCard, BCardText,
} from 'bootstrap-vue'
import titleSection from '@/views/components/title-section.vue'

export default {
  components: {
    titleSection,
    BCard,
    BCardText,
  },
  data() {
    return {
      requerimientos: [
        {
          titulo: 'Sistemas operativos soportados',
          particular: [
            { text: 'macOS X con macOS 10.7 o posterior.' },
            { text: 'Windows 10 | Windows 7' },
          ],
        },
        {
          titulo: 'Tablet y dispositivos móviles compatibles',
          particular: [
            { text: 'Dispositivos iOS.' },
            { text: 'Dispositivos Android' },
          ],
        },
        {
          titulo: 'Navegadores compatibles',
          particular: [
            { text: 'Windows: Preferentemente Firefox 56+ | Chrome 20+ | IE 11+ | Edge 90+' },
            { text: 'Mac: Safari 13+ | Firefox 56+ | Chrome 85+' },
          ],
        },
        {
          titulo: 'Requerimientos de procesador y RAM',
          particular: [
            { text: 'Procesador Dual Core 2Ghz o superior (i3 / i5 / i7 o equivalente AMD)' },
            { text: 'RAM 4GB' },
          ],
        },
        {
          titulo: 'Requerimientos ancho de banda',
          particular: [
            { text: 'Una conexión a Internet: banda ancha por cable preferentemente o inalámbrica (3G o 4G / LTE).' },
            { text: 'Mínimo: 1.8 Mbps para recibir video 720p.' },
            { text: 'Recomendado: 3.0 Mbps para recibir video de 1080p.' },
          ],
        },
      ],
    }
  },
}
</script>
